/**
 * 财务--》结款核销
 */

export default {
  // 结款核销（送货费）替换右边gridId
  change_settlementVerification_righttGridId: ['82565'], // 202506101058099078510
  custom_taxes_expenditure: ['93817'], // 202504171417535434156，93817 定制 核销，请款，应收应付汇总表，网点利润表（税金）
  hx_summary_filling_with_unit: ['98380'], // 202506091412033438889，98380 仅定制 核销生成日记账摘要中携带unit
  custom_hx_summary_filling_with_unit: ['82447', '98380'], //非公版202507241730372502868需求中 "82447","98380"以前已定制该企业下全部摘要中带入运单号

  // 结款核销页面，右侧表格修复重复数据
  // https://imagecdn.ymm56.com/ymmfile/static/resource/ad4d96cc-5a41-4f5c-837c-900e2d4fa8a8.png
  hx_right_grid_fix_repeating_data: ['93586', '83062'], // 202502271146106409920、202508081031120335826
  // 核销回扣开启 表格键盘上下左右切换
  hx_hk_use_keyup_to_jump: ['99800'], // 202511241445397776476
  // 超过最大限制分批核销
  hx_batch_verification: ['72680','90100'], // 202512121018279677274
  // 交互上支持切换checkbox模式选择核销(在核销列表前加checkbox)
  hx_support_batch_verification: ['90100','90609'], // 202512191504287433504
  //选择自定义日期刷新并请求今日数据
  hx_refresh_data_with_today: ['76792'], // 202601241804015838400
}
